import { Directive, EventEmitter, HostListener, Input, Output } from '@angular/core'
import { FormControl, FormGroup } from '@angular/forms'

@Directive()
export abstract class EditComponent {
  @Input() control: FormControl | undefined
  @Input() parentForm: FormGroup | undefined
  @Input() inputClass: string | undefined
  @Input() placeholder: string = ''
  @Input() mandatory: boolean | undefined
  @Input() showFloatLabel = false
  @Input() autoSelect = false

  @Output() onEnter: EventEmitter<void> = new EventEmitter()
  @Output() onEscape: EventEmitter<void> = new EventEmitter()
  @Output() onTab: EventEmitter<void> = new EventEmitter()
  @Output() onClickOutside: EventEmitter<void> = new EventEmitter()
  @Output() onFocus: EventEmitter<void> = new EventEmitter()
  @Output() onUpdate: EventEmitter<void> = new EventEmitter()

  emitUpdate() {
    this.onUpdate.emit()
  }

  emitEnter() {
    this.onEnter.emit()
  }

  emitEscape() {
    this.onEscape.emit()
  }

  emitTab() {
    this.onTab.emit()
  }

  emitClickOutside() {
    this.onClickOutside.emit()
  }

  emitFocus() {
    this.onFocus.emit()
  }

  protected emitOutsideClick = true // set in DateInputComponent
  private inside = false
  private isDragging = false
  // listens to any click
  @HostListener('document:click')
  clickedOutside() {
    if (!this.inside && !this.isDragging && this.emitOutsideClick) {
      this.emitClickOutside()
    }
    this.inside = false
    this.isDragging = false
  }

  // listens to clicks that originate within this component instance
  @HostListener('click')
  clickedInsideCell() {
    this.inside = true
    /**
     * In DropDownCell jmlStopClickPropagation directive stops click event bubbling to prevent selecting a line in the table.
     * Consequently the click is not populated to clickedOutside() and the flag this.inside is not reset to false.
     * Quick hack here is to always reset it after 50ms. This would only be a problem for users who click to
     * another dropdown within 50ms which would be inhumanly quick. So it should be ok.
     * However, this is a hack. :-(
     * */
    setTimeout(() => (this.inside = false), 50)
  }

  // listens to mousedown within this component instance
  @HostListener('mousedown', ['$event'])
  onMouseDown() {
    this.isDragging = true
  }

  // listens to mouseup within this component instance
  @HostListener('mouseup', ['$event'])
  onMouseUp() {
    this.isDragging = false
  }
}
